import { GetMovimientosTarjetaBancariaByFiltersDtoProps } from "./DTOs/GetMovimientosTarjetaBancariaByFiltersDto"
import { GetTarjetasBancariasByFiltersDtoProps } from "./DTOs/GetTarjetasBancariasByFiltersDto"
import { GetTarjetasBancariasByIdDtoProps } from "./DTOs/GetTarjetasBancariasByIdDto"

export const MovimientoTarjetaAdapter = (
  movimientoTarjeta: GetMovimientosTarjetaBancariaByFiltersDtoProps
): GetMovimientosTarjetaBancariaByFiltersDtoProps => ({
  id: movimientoTarjeta.id,
  descripcion: movimientoTarjeta.descripcion,
  fechaOperacion: movimientoTarjeta.fechaOperacion,
  fechaValor: movimientoTarjeta.fechaValor,
  importe: movimientoTarjeta.importe,
  saldo: movimientoTarjeta.saldo,
})

export const TarjetaBancariaByIdAdapter = (
  tarjeta: GetTarjetasBancariasByIdDtoProps
): GetTarjetasBancariasByIdDtoProps => ({
  descripcion: tarjeta.descripcion,
  entidadBancaria: tarjeta.entidadBancaria,
  fechaUltimaActualizacion: tarjeta.fechaUltimaActualizacion,
  idExterno: tarjeta.idExterno,
  numero: tarjeta.numero,
  nombre: tarjeta.nombre,
  saldo: tarjeta.saldo,
  service: tarjeta.service,
  tipo: tarjeta.tipo,
})

export const tarjetaBancariaByFiltersAdapter = (
  tarjeta: GetTarjetasBancariasByFiltersDtoProps
): GetTarjetasBancariasByFiltersDtoProps => ({
  id: tarjeta.id,
  descripcion: tarjeta.descripcion,
  fechaUltimaActualizacion: tarjeta.fechaUltimaActualizacion,
  entidadBancaria: tarjeta.entidadBancaria,
  numero: tarjeta.numero,
  nombre: tarjeta.nombre,
  saldo: tarjeta.saldo,
  service: tarjeta.service,
  tipo: tarjeta.tipo,
})
